//@ts-ignore
import { tw } from "@careinfo/tailwind";
import React from "react";
import { useForm } from "react-hook-form";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import GridCard from "./GridCard";
import Button from "./Reusable/Button";
import Modal from "./Reusable/Modal";

const animatedComponents = makeAnimated();

const RiderSetting = (props: any) => {
  const {
    statusList,
    patchLoading,
    handleStatusInclude,
    gridData,
    openEditPopup,
    setOpenEditPopup,
    handleEditStatusChange,
    defaultValue,
    handleOpenEditPopup,
  } = props;
  const { getValues } = useForm<any>();
  return (
    <>
      <div className={tw`grid grid-cols-5 gap-x-8 gap-y-4`}>
        {gridData?.map((item: any, index: number) => (
          <React.Fragment key={index}>
            <GridCard
              key={index}
              item={item}
              props={{ ...getValues() }}
              handleOpenEditPopup={handleOpenEditPopup}
            />
          </React.Fragment>
        ))}
      </div>
      <Modal
        isOpen={openEditPopup}
        setIsOpen={setOpenEditPopup}
        title={"Select Status To Include"}
      >
        <div className={tw`mt-4`}>
          <form
            autoComplete="off"
            className={tw`flex gap-x-4 items-center justify-center`}
          >
            <div className={tw`w-3/4`}>
              <Select
                components={animatedComponents}
                closeMenuOnSelect={false}
                options={statusList}
                onChange={handleEditStatusChange}
                value={(() => {
                  return defaultValue.map((d) => ({
                    ...d,
                    value: d.id,
                    name: d.label,
                  }));
                })()}
                isMulti
              />
            </div>

            <div className={tw`w-[100px] `}>
              <Button
                label={"Update"}
                type={"button"}
                onClick={(e: any) => handleStatusInclude(e)}
                isLoading={patchLoading}
              />
            </div>
          </form>
        </div>
      </Modal>
    </>
  );
};

export default RiderSetting;
